import { render, staticRenderFns } from "./RgDateInputDialog.vue?vue&type=template&id=2ba80d79&"
import script from "./RgDateInputDialog.vue?vue&type=script&lang=js&"
export * from "./RgDateInputDialog.vue?vue&type=script&lang=js&"
import style0 from "./RgDateInputDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports